import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import IconBack from "@/assets/icons/icon__back.svg";
import { useRouter } from "vue-router";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'BackLinkTitle',
  props: {
    title: {}
  },
  setup(__props: any) {



const router = useRouter();

function goBack() {
  router.back();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
    class: "back-link-title"
  }, [
    _createVNode(_unref(IconBack), { class: "icon" }),
    _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1)
  ]))
}
}

})